<template>
  <b-container>
    <h2>js-tools</h2>
    <div class="row mt-3">
      <b-input v-model="value" placeholder="input something...." />
      {{ createEncode(value) }}
    </div>
  </b-container>
</template>

<script>
import CryptoJS from "crypto-js";

export default {
  name: "crypto-js",
  data: () => ({
    value: "Message",
  }),
  methods: {
    createEncode(value) {
      return CryptoJS.AES.encrypt(`${value}`, "1");
      //   return CryptoJS.HmacSHA1(value, "thuandv");
      //   return CryptoJS.SHA256(value);
      //   return CryptoJS.AES.encrypt(value, "thuandv");
    },
  },
};
</script>
